// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SenderName__sender-name-fed9a8 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  text-decoration: none;
  cursor: pointer;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
}

.SenderName__sender-name-fed9a8.SenderName__color0-d93601 {
  color: var(--avatar-0);
}

.SenderName__sender-name-fed9a8.SenderName__color1-fb0563 {
  color: var(--avatar-10);
}

.SenderName__sender-name-fed9a8.SenderName__color2-ff09df {
  color: var(--avatar-20);
}

.SenderName__sender-name-fed9a8.SenderName__color3-c70e2b {
  color: var(--avatar-30);
}

.SenderName__sender-name-fed9a8.SenderName__color4-f947db {
  color: var(--avatar-40);
}

.SenderName__sender-name-fed9a8.SenderName__color5-d8e825 {
  color: var(--avatar-50);
}

.SenderName__sender-name-fed9a8.SenderName__color6-f7b34a {
  color: var(--avatar-60);
}

.SenderName__sender-name-fed9a8.SenderName__color7-c8ac57 {
  color: var(--avatar-70);
}

.SenderName__sender-name-fed9a8.SenderName__color8-b8c3a0 {
  color: var(--avatar-80);
}

.SenderName__sender-name-fed9a8.SenderName__color9-da59f3 {
  color: var(--avatar-90);
}

.SenderName__name-eee90f {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.SenderName__loader-e222cc {
  margin-inline-start: 6px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/SenderName/SenderName.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".sender-name {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  text-decoration: none;\n  cursor: pointer;\n  max-width: 100%;\n  display: inline-flex;\n  align-items: center;\n}\n\n.sender-name.color0 {\n  color: var(--avatar-0);\n}\n\n.sender-name.color1 {\n  color: var(--avatar-10);\n}\n\n.sender-name.color2 {\n  color: var(--avatar-20);\n}\n\n.sender-name.color3 {\n  color: var(--avatar-30);\n}\n\n.sender-name.color4 {\n  color: var(--avatar-40);\n}\n\n.sender-name.color5 {\n  color: var(--avatar-50);\n}\n\n.sender-name.color6 {\n  color: var(--avatar-60);\n}\n\n.sender-name.color7 {\n  color: var(--avatar-70);\n}\n\n.sender-name.color8 {\n  color: var(--avatar-80);\n}\n\n.sender-name.color9 {\n  color: var(--avatar-90);\n}\n\n.name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.loader {\n  margin-inline-start: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sender-name": `SenderName__sender-name-fed9a8`,
	"senderName": `SenderName__sender-name-fed9a8`,
	"color0": `SenderName__color0-d93601`,
	"color1": `SenderName__color1-fb0563`,
	"color2": `SenderName__color2-ff09df`,
	"color3": `SenderName__color3-c70e2b`,
	"color4": `SenderName__color4-f947db`,
	"color5": `SenderName__color5-d8e825`,
	"color6": `SenderName__color6-f7b34a`,
	"color7": `SenderName__color7-c8ac57`,
	"color8": `SenderName__color8-b8c3a0`,
	"color9": `SenderName__color9-da59f3`,
	"name": `SenderName__name-eee90f`,
	"loader": `SenderName__loader-e222cc`
};
module.exports = ___CSS_LOADER_EXPORT___;
